import React from 'react';
import Header from './Header';

const Home = () => (
    <div className="m- p-0">

        <Header page={'Software Engineer'}
                focus={'Python, DevOps, Amazon Web Services (AWS), JavaScript'}
        />

    </div>
);

export default Home;